<!-- 专业-修改弹框 -->
<template lang="pug">
div
  van-action-sheet(v-if="!multiple" v-model="popupShow" :actions="actions" cancel-text="清空" close-on-click-action @select="onSelect" @cancel="clear")
  van-action-sheet(v-if="multiple" v-model="popupShow" cancel-text="清空" close-on-click-action @cancel="clear")
    button.van-action-sheet__item(v-for="(item,index) in actions" :key="index" :class="item.isSelected? 'isSelected':''" @click="onSelect(item)") {{ item.name }}
      i.el-icon-check.el-icon--right(v-if="item.isSelected")
</template>

<script>
import { mapState } from "vuex";
import questionService from "@/CommonDP/service/question-service";

export default {
  props: {
    multiple: { type: Boolean, default: false } // 多选
  },
  components: {},
  data() {
    return {
      popupShow: false,
      actions: [] // 选项
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {},
  methods: {
    // 初始化
    init(prjId, fileId, list) {
      this.getDic(prjId, fileId);
      // 默认选中项
      if (list) {
        this.actions.forEach((e) => {
          if (list.some((item) => item.specName === e.name)) this.$set(e, "isSelected", true);
        });
      }
    },
    // 清空
    clear() {
      if (this.multiple) {
        this.actions.forEach((e) => {
          this.$set(e, "isSelected", false);
        });
        this.$emit("callback", []);
      } else {
        this.$emit("callback", {});
      }
    },

    // 获得可选值
    async getDic(prjId, fileId) {
      let dicList = {};
      if (prjId && !fileId) {
        const { data } = await questionService.getH5DrawingQuestionSearchList(prjId);
        dicList = data || {};
      } else if (prjId && fileId) {
        const { data } = await questionService.queryDict2(prjId, fileId);
        dicList = data || {};
      }
      let specStageChildVos = dicList.specStageChildVos || [];
      let specList = specStageChildVos.find((ele) => ele.name === "专业")?.optionalValues || [];
      this.actions = specList.map((e) => {
        return { name: e.cnName, ...e };
      });
    },
    // 选中事件
    onSelect(item) {
      if (this.multiple) {
        if (item.isSelected) this.$set(item, "isSelected", false);
        else this.$set(item, "isSelected", true);
        this.callback();
      } else {
        this.$emit("callback", item);
      }
    },
    // 回调
    callback() {
      let selectedList = this.actions.filter((e) => e.isSelected);
      this.$emit("callback", selectedList);
    }
  }
};
</script>

<style lang="scss" scoped>
.isSelected {
  color: var(--theme-color, #4777e7);
}
</style>
